module.exports = __webpack_public_path__ + "static/media/05_twitter_image.7ff4ce5a.jpg";